import {contractUtil} from '@/helper/contract';

export function genSymbolOptions(currency, contracts, all) {
  const items = contracts
    .filter((contract) => contract.settleCurrency === currency)
    .map((item) => {
      const {symbol, symbolV2, settleCurrency, settleCurrencyDisplay, baseCurrency} = item;
      return {
        text: symbolV2,
        value: symbol,
        settleCurrency,
        settleCurrencyDisplay,
        baseCurrency,
      };
    });
  return [{value: '', text: all}, ...items];
}

/**
 *
 * @param {*} contracts
 * @param {{hasPtCurrency?: boolean, isV2?: boolean, isPilotContract?: boolean, noUsd?: boolean}} param1
 * @returns
 */
export function genAccountOptions(contracts, {hasPtCurrency, isV2, isPilotContract, noUsd} = {hasPtCurrency: false, isV2: false, isPilotContract: null, noUsd: false}) {
  const contracts2 = typeof isPilotContract === 'boolean' ? contracts.filter((o) => contractUtil.isPilotContractV1(o.originType) === isPilotContract) : contracts;
  const settleCurrencies = contracts2.reduce((p, c) => (p.has(c.settleCurrency) ? p : p.set(c.settleCurrency, c.settleCurrencyDisplay)), new Map());
  if (hasPtCurrency) {
    settleCurrencies.set('PT', 'PT');
  }
  if (noUsd) {
    settleCurrencies.delete('USD');
  }
  return Array.from(settleCurrencies.keys()).map((currency) => {
    const text = settleCurrencies.get(currency);
    return {value: currency, text: isV2 ? (currency === 'PUSD' ? 'Pilot - ' : '') + text : text};
  });
}

export function genOrderDirection(contracts, order, LG, lang) {
  const contract = contracts.find((o) => o.symbol === order.symbol);
  if (!contract) {
    return '-';
  }
  const {type} = contract;
  const {side, posSide} = order;
  /**
   * side: 1 => Buy 2 => Sell
   * posSide 0 => Invalid; 1 => Long; 2 => Short; 3 => Merged
   * **/
  const isBuy = side === 1;
  if (type === 'Perpetual') {
    return LG(lang[isBuy ? 'Long' : 'Short']);
  }
  if (type === 'PerpetualV2') {
    if (posSide === 1) {
      return LG(lang[isBuy ? 'OpenLong' : 'CloseLong']);
    }
    if (posSide === 2) {
      return LG(lang[isBuy ? 'CloseShort' : 'OpenShort']);
    }
    if (posSide === 3) {
      return LG(lang[isBuy ? 'Long' : 'Short']);
    }
  }
  return '-';
}
